// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"726e1942","381":"9d1b5b39","471":"8ec5cd5e","724":"b7800c11"}[chunkId] + ".chunk.js";
};